/**
 * This hook is used to check if the Revenue OTR menu should be displayed or not.
 * The Revenue OTR menu should not be displayed if the user is in a OneID enabled Billing tenant
 * and the linked Revenue tenant is also migrated to OneID.
 * This can be identified by checking if the Revenue tenant is present in the app switcher data and linked to the current Billing tenant.
 */
import { useAppSwitcherData } from './useAppSwitcherData';

export const useRevenueOTRMenuCheck = (billingNavData) => {
  const { isEnabled: isZASTokenEnabled } = useAppSwitcherData();
  if (isZASTokenEnabled && billingNavData?.menus) {
    const filteredMenus = billingNavData.menus.filter(
      (menu) => menu.id !== 'Zuora/RevPro',
    );
    return {
      data: {
        ...billingNavData,
        menus: filteredMenus,
      },
    };
  }
  return {
    data: billingNavData,
  };
};
